export enum EventStatus {
  ACTIVE = 'active',
  CLEARED = 'cleared',
}
